// theme.ts
import { createTheme } from "@mantine/core";
import { tokens } from "./design-system-tokens.js";

export const theme = createTheme({
  primaryColor: "primary",
  black: "#000",
  autoContrast: true,
  colors: tokens.colors,

  // #region components
  components: {
    Button: { defaultProps: { color: "primary" } },
    TextInput: { defaultProps: { color: "primary" } },
    PasswordInput: { defaultProps: { color: "primary" } },
    Select: { defaultProps: { color: "primary" } },
    Checkbox: { defaultProps: { color: "primary" } },
    Radio: { defaultProps: { color: "primary" } },
    Switch: { defaultProps: { color: "primary" } },
    Badge: { defaultProps: { color: "primary" } },
  },

  // radius: tokens.radius,
  defaultRadius: tokens.defaultRadius,
  shadows: tokens.shadows,
});
